<template>
  <div v-if="photo">
    <v-img v-if="addedFiles.length && isImage(addedFiles[0])" :src="getImageUrl(addedFiles[0])" max-height="230px"></v-img>
    <input type="file" style="display: none" ref="fileInput" :multiple="!singleFile" @change="onFileSelected" accept="image/*, .jfif">
  </div>
  <div v-else>
    <v-flex v-show="!addedFilesIsEmpty" mt-1>
      <v-card v-if="description">
        <v-data-table :items="addedFiles" hide-actions hide-headers no-data-text="No hay datos disponibles">
          <template slot="items" slot-scope="props">
            <tr class="row-element" :key="props.item.name">
              <td>
                <v-flex py-2>
                  <v-img v-if="isImage(props.item)" :src="getImageUrl(props.item)" max-height="100" width="150" slot="activator"></v-img>
                </v-flex>
              </td>

              <td>Subiendo archivo...</td>
              <td v-if="Object.keys(progress).length !== 0">
                <v-progress-circular class="progress" :value="progressFor(props.item.name)" width="3" size="32" color="blue">
                  {{ progressFor(props.item.name) }}
                </v-progress-circular>
              </td>

              <td v-if="isImageOrPdf(props.item)">
                <a :href="getImageUrl(props.item)" rel="nofollow norefferer noopener" target="_blank">{{ props.item.name }}</a>
              </td>
              <td v-else>
                <a :download="props.item.name" :href="getImageUrl(props.item)" rel="nofollow norefferer noopener" target="_blank">{{ props.item.name }}</a>
              </td>

              <td>{{ humanFileSize(props.item.size) }}</td>

              <td class="text-xs-right">
                <v-btn v-if="Object.keys(progress).length === 0" icon @click="remove(props.item)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-card v-else class="grey lighten-4">
        <v-container fluid grid-list-sm>
          <v-layout>
            <v-flex xs6 sm3 v-for="file in addedFiles" :key="file.name">
              <v-tooltip bottom>
                <v-img v-if="isImage(file)" :src="getImageUrl(file)" max-height="250" max-width="250" slot="activator"></v-img>
                <span>{{ file.name }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-container>
        <v-chip v-for="file in addedFiles" :key="file.name" :close="Object.keys(progress).length === 0" @input="remove(file)" class="attach-chip">
          <v-progress-circular class="progress" :value="progressFor(file.name)" width="3" size="32" color="blue">
            {{ progressFor(file.name) }}
          </v-progress-circular>
          {{ file.name }}
        </v-chip>
      </v-card>
      <v-card-actions>
        <input
          type="file"
          style="display: none"
          ref="fileInput"
          :multiple="!singleFile" @change="onFileSelected"
          :accept=" !onlyImage ? 'image/*, video/*, .pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'image/*' ">
      </v-card-actions>
    </v-flex>
  </div>
</template>

<script>

export default {
  props: {
    description: Boolean,
    singleFile: Boolean,
    photo: Boolean,
    onlyImage: Boolean
  },

  data () {
    return {
      addedFiles: [],
      progress: {},
      images: {}
    }
  },

  methods: {
    sendFilesToParent (result) {
      this.$emit('upload', result)
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFileSelected (event) {
      if (this.singleFile && this.addedFilesHasAnItem() && !this.photo) {
        this.$refs.fileInput.value = null
        return
      }
      const files = event.target.files
      if (this.photo) {
        if (files[0].name.length > 120) {
          this.$store.commit('setCustomErrorMsg', 'Nombre del archivo demasiado largo.')
          this.$refs.fileInput.value = null
          return
        }
        this.addedFiles.splice(0, 0, files[0])
      } else {
        for (let i = 0; i < files.length; i++) {
          if (files[i].name.length > 120) {
            this.$store.commit('setCustomErrorMsg', `Nombre del archivo demasiado largo.`)
            continue
          }
          const isVideo = files[i].type.match('video.*')
          const maxVideoSize = 300 * 1024 * 1024

          if (isVideo && files[i].size > maxVideoSize) {
            this.$store.commit('setCustomErrorMsg', `El video "${files[i].name}" supera el límite permitido de 300 MB.`)
            continue
          }

          if ((this.addedFiles.filter(file => file.name === files[i].name)).length === 0) {
            if (!this.onlyImage && (files[i].type.match('image.*') || files[i].type.match('video.*') || files[i].type.match('.pdf') ||
                files[i].type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                files[i].type.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document'))) {
              this.addedFiles.push(files[i])
            } else if (this.onlyImage && files[i].type.match('image.*')) {
              this.addedFiles.push(files[i])
            } else {
              this.$store.commit('setCustomErrorMsg', 'Formato de archivo no válido.')
            }
          }
        }
      }
      this.sendFilesToParent(this.addedFiles)
      this.$refs.fileInput.value = null
    },
    cleanContent () {
      this.addedFiles = []
      this.progress = {}
      this.images = {}
    },
    cleanProgress () {
      this.progress = {}
    },
    updateProgressFor (filename, x) {
      this.$set(this.progress, filename, Math.floor(x))
    },
    progressFor (fileName) {
      if (this.progress[fileName]) {
        return this.progress[fileName]
      } else {
        return '0'
      }
    },
    remove (item) {
      this.addedFiles.splice(this.addedFiles.indexOf(item), 1)
      this.addedFiles = [...this.addedFiles]
      this.sendFilesToParent(this.addedFiles)

      this.$delete(this.progress, item.name)
      this.$delete(this.images, item.name)
    },
    isImage (file) {
      return file.type.match('image.*')
    },
    isImageOrPdf (file) {
      return (file.type.match('image.*') || file.type.match('application/pdf') || file.type.match('video.*'))
    },
    getImageUrl (file) {
      if (!this.images[file.name]) {
        this.images[file.name] = URL.createObjectURL(file)
      }
      return this.images[file.name]
    },
    humanFileSize (size) {
      let i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
    },
    addedFilesHasAnItem () {
      return this.addedFiles.length === 1
    }
  },

  computed: {
    addedFilesIsEmpty () {
      return this.addedFiles.length === 0
    }
  }
}
</script>

<style scoped>
.row-element {
  background-color: #f0f0f2;
}
.progress {
  height: 32px;
  width: 32px;
  margin-right: 6px;
}
.attach-chip {
  height: 40px;
}
</style>
